import { useMemo, useState } from 'react';
import { Box, Grid, Snackbar, Stack } from '@mui/material';
import { FormTitleBox } from '../../../common/components';
import AudienceSelector from './components/AudienceSelector';
import MessageComposer from './components/MessageComposer';
import SendChecklist from './components/SendChecklist';
import { usePushNotificationComposer } from './hooks/usePushNotificationComposer';

const PushNotifications = () => {
  const {
    message,
    filters,
    preview,
    recipients,
    groupOptions,
    contractOptions,
    loadingGroups,
    loadingContracts,
    isSending,
    updateMessage,
    appendEmoji,
    updateFilters,
    sendToBackend,
  } = usePushNotificationComposer();

  const [toast, setToast] = useState({ open: false, message: '' });

  const summaryItems = useMemo(
    () => [
      { label: 'Audiencia', value: preview.audienceLabel || 'Definí un filtro' },
      { label: 'Estilo', value: message.emphasis === 'bold' ? 'Enfatizado' : message.emphasis === 'light' ? 'Liviano' : 'Equilibrado' },
      { label: 'Suscriptores destino', value: `${recipients.length} seleccionados` },
    ],
    [message.emphasis, preview.audienceLabel, recipients.length]
  );

  const handleSend = async () => {
    try {
      const response = await sendToBackend();
      setToast({
        open: true,
        message: `Notificaciones enviadas: ${response?.success ?? 0} éxito(s), ${response?.failure ?? 0} fallo(s)`,
      });
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || 'Error al enviar push';
      setToast({ open: true, message: msg });
    }
  };

  const handleCloseToast = () => setToast({ open: false, message: '' });

  return (
    <Box>
      <FormTitleBox title="Notificaciones push | Habitat 99" />

      <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <MessageComposer
            message={message}
            preview={preview}
            onMessageChange={updateMessage}
            onAddEmoji={appendEmoji}
          />
        </Grid>

        <Grid item xs={12} md={5}>
          <Stack spacing={0.1}>
            <AudienceSelector
              groupOptions={groupOptions}
              contractOptions={contractOptions}
              loadingGroups={loadingGroups}
              loadingContracts={loadingContracts}
              filters={filters}
              onFiltersChange={updateFilters}
            />

            <SendChecklist
              summaryItems={summaryItems}
              onSend={handleSend}
              canSend={Boolean(message.body && message.title && recipients.length)}
              isSending={isSending}
            />
          </Stack>
        </Grid>
      </Grid>

      <Snackbar
        open={toast.open}
        autoHideDuration={3500}
        onClose={handleCloseToast}
        message={toast.message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Box>
  );
};

export default PushNotifications;
